import { useAtomValue } from 'jotai';

import { participantsAtom, remoteScreenShareParticipantAtom } from '../../video-sdk';
import { LocalScreenShare } from './LocalScreenShare';
import { MediaShareLayout, MediaShareLayoutProps } from './MediaShareLayout';
import { RemoteScreenShare } from './RemoteScreenShare';

export function MediaShareLayoutWrapper({
  thumbnail,
  remoteParticipantComponent: RemoteParticipantComponent,
}: Pick<MediaShareLayoutProps, 'thumbnail' | 'remoteParticipantComponent'>) {
  const participants = useAtomValue(participantsAtom);
  const remoteScreenShareParticipant = useAtomValue(remoteScreenShareParticipantAtom);

  return (
    <MediaShareLayout
      remoteParticipants={participants}
      remoteScreenShareParticipant={remoteScreenShareParticipant}
      remoteParticipantComponent={RemoteParticipantComponent}
      thumbnail={thumbnail}
      sharedMediaComponent={
        <>
          <LocalScreenShare />
          {remoteScreenShareParticipant && <RemoteScreenShare />}
        </>
      }
    />
  );
}
